<template>
  <div class="container">
    <p>Listado de marcos legales generales</p>
  </div>
</template>
